export class AzureResourceGroups {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceGroups",
            "baseName": "resourceGroups",
            "type": "Array<AzureResourceGroup>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureResourceGroups.attributeTypeMap;
    }
    constructor() {
    }
}
